module.exports = __webpack_public_path__ + "static/media/share.59d99e7b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/black/share.svg
// module id = 1346
// module chunks = 0